module.exports = __webpack_public_path__ + "media/entities/2001-511373f9.png";